import React from 'react';
import { Select, MenuItem } from '@mui/material';

const CustomSelectField = ({ field , data, defaultLabel }) => {
  return (
    <Select
      value={field.value}
      onChange={field.onChange}
      displayEmpty
      fullWidth
      size="small"
      sx={{
        backgroundColor: "white",
        borderRadius: "5px",
        "& .MuiSelect-select": {
          color: "#e8442d",
        },
        "& .MuiSelect-icon": {
          color: "#e8442d",
        },
        "& .MuiSelect-select:focus": {
          backgroundColor: "white",
        },
        "& .MuiSelect-select.MuiSelect-select": {
          backgroundColor: "white",
        },
      }}
    >
      <MenuItem value="">
        {defaultLabel}
      </MenuItem>
      {data.map((item) => (
        <MenuItem key={item} value={item}>
          {item}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelectField;